"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.minMaxToStringArrayParser = exports.commaListParser = void 0;
var commaListParser = exports.commaListParser = function commaListParser(list) {
  return list === null || list === void 0 ? void 0 : list.map(function (_ref) {
    var name = _ref.name;
    return name;
  }).join(', ');
};
var minMaxToStringArrayParser = exports.minMaxToStringArrayParser = function minMaxToStringArrayParser(value) {
  var result = [(value === null || value === void 0 ? void 0 : value.min) !== undefined ? value.min : '-', (value === null || value === void 0 ? void 0 : value.max) !== undefined ? value === null || value === void 0 ? void 0 : value.max : ''];
  return result;
};